// extracted by mini-css-extract-plugin
export default {"card":"NoticeCard_card__NDBc9","note":"NoticeCard_note__Z9MPC","editIcon":"NoticeCard_editIcon__Xyqet"};